import React, {useContext} from 'react';
import {ThemeContext} from '../context/theme-context';
import styles from '../styles/Header.module.css';
import aboutStyles from '../styles/About.module.css';
import {handleCVDownload} from './util.js'
import {
    FaCode,
    FaLaptopCode,
    FaTerminal,
    FaFileDownload, FaLinkedin, FaSkype, FaWhatsapp, FaGoogle, FaEnvelope, FaPhone, FaMapMarkerAlt
} from 'react-icons/fa';
import {
    SiCodemagic,
    SiHiveBlockchain
} from 'react-icons/si';

function Header() {
    const {theme} = useContext(ThemeContext);

    // Array of programming/tech icons
    const TechIcons = [
        FaCode,
        FaLaptopCode,
        FaTerminal,
        SiCodemagic,
        SiHiveBlockchain
    ];

    // Randomly select an icon based on theme
    const SelectedIcon = TechIcons[
        theme === 'light'
            ? Math.floor(Math.random() * TechIcons.length)
            : Math.floor(Math.random() * TechIcons.length)
        ];

    const socialLinks = [
        {
            icon: <FaLinkedin/>,
            href: 'https://be.linkedin.com/in/leeroy-msizi-kamafu-5a01a899',
            label: 'LinkedIn'
        },
        {
            icon: <FaSkype/>,
            href: 'https://join.skype.com/invite/gXaFb2epQvP2',
            label: 'Skype'
        },
        {
            icon: <FaWhatsapp/>,
            href: 'https://wa.me/+32498060528',
            label: 'WhatsApp'
        },
        {
            icon: <FaGoogle/>,
            href: 'mailto:ncubelee04@gmail.com',
            label: 'GMail'
        }
    ];

    const personalDetails = [
        {
            icon: <FaEnvelope className={aboutStyles.detailIcon}/>,
            text: 'ncubelee04@gmail.com',
        },
        {
            icon: <FaPhone className={aboutStyles.detailIcon}/>,
            text: '+32 498 06 05 28'
        },
        {
            icon: <FaMapMarkerAlt className={aboutStyles.detailIcon}/>,
            text: 'Aalst, Belgium'
        }
    ];

    return (
        <section
            id="home"
            className={styles.header}
            data-theme={theme}
        >
            <div className="container">
                <div className={styles.headerContent}>
                    <div className={styles.headerTextContainer}>
                        <h1 className={styles.headerTitle}>
                            Leeroy Msizi Ncube
                        </h1>
                        <h2 className={styles.headerSubtitle}>
                            Senior Software Engineer
                        </h2>
                        <div className={aboutStyles.personalDetails}>
                            {personalDetails.map((detail, index) => (
                                <div key={index} className={aboutStyles.detailItem}>
                                    {detail.icon}
                                    <span className={aboutStyles.detailText}>
                    {detail.text}
                  </span>
                                </div>
                            ))}
                        </div>
                        <p className={styles.headerDescription}>
                            Java microservices expert adept at crafting scalable solutions with Spring Boot, AWS, and
                            Kubernetes. <br/> Specializes in modern JavaScript technologies, with a focus on Angular &
                            React.<br/>
                            Driven by clean code, CI/CD automation, and cutting-edge technology.
                        </p>

                        <div className={styles.headerCta}>
                            <a
                                href="#contact"
                                className={`${styles.ctaButton} ${styles.primaryButton}`}
                            >
                                Hire Me
                            </a>
                            <button
                                onClick={handleCVDownload}
                                className={`${styles.ctaButton} ${styles.secondaryButton}`}
                                aria-label="Download CV"
                            >
                                <FaFileDownload style={{marginRight: '0.5rem'}}/>
                                Download CV
                            </button>
                        </div>
                    </div>
                    <div className={aboutStyles.socialLinks}>
                        {socialLinks.map((link, index) => (
                            <a
                                key={index}
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={aboutStyles.socialLink}
                                aria-label={link.label}
                            >
                                {link.icon}
                            </a>
                        ))}
                    </div>

                    <div className={styles.headerImageContainer}>
                        <div className={styles.headerIconWrapper}>
                            <SelectedIcon className={styles.headerIcon}/>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Header;